export default { "columns":36,
 "image":"inside_cave_building.png",
 "imageheight":704,
 "imagewidth":576,
 "margin":0,
 "name":"inside_cave_building",
 "spacing":0,
 "tilecount":1584,
 "tiledversion":"1.11.2",
 "tileheight":16,
 "tiles":[
        {
         "id":96,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":16,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":8,
                     "x":8,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ladder"
        }, 
        {
         "id":97,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":16,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":8,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ladder"
        }, 
        {
         "id":132,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":16,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":8,
                     "x":8,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ladder"
        }, 
        {
         "id":133,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":16,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":8,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ladder"
        }, 
        {
         "id":168,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":16,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":8,
                     "x":8,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ladder"
        }, 
        {
         "id":169,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":16,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":8,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ladder"
        }, 
        {
         "id":204,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":16,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":8,
                     "x":8,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ladder"
        }, 
        {
         "id":205,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":16,
                     "id":1,
                     "name":"",
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":8,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ladder"
        }, 
        {
         "id":305,
         "type":"ground"
        }, 
        {
         "id":307,
         "type":"ground"
        }, 
        {
         "id":309,
         "type":"ground"
        }, 
        {
         "id":310,
         "type":"ground"
        }, 
        {
         "id":311,
         "type":"ground"
        }, 
        {
         "id":312,
         "type":"ground"
        }, 
        {
         "id":314,
         "type":"ground"
        }, 
        {
         "id":315,
         "type":"ground"
        }, 
        {
         "id":316,
         "type":"ground"
        }, 
        {
         "id":317,
         "type":"ground"
        }, 
        {
         "id":319,
         "type":"ground"
        }, 
        {
         "id":320,
         "type":"ground"
        }, 
        {
         "id":321,
         "type":"ground"
        }, 
        {
         "id":322,
         "type":"ground"
        }, 
        {
         "id":341,
         "type":"ground"
        }, 
        {
         "id":343,
         "type":"ground"
        }, 
        {
         "id":377,
         "type":"ground"
        }, 
        {
         "id":379,
         "type":"ground"
        }, 
        {
         "id":381,
         "type":"ground"
        }, 
        {
         "id":382,
         "type":"ground"
        }, 
        {
         "id":383,
         "type":"ground"
        }, 
        {
         "id":421,
         "type":"platform"
        }, 
        {
         "id":422,
         "type":"platform"
        }, 
        {
         "id":423,
         "type":"platform"
        }, 
        {
         "id":424,
         "type":"platform"
        }, 
        {
         "id":425,
         "type":"platform"
        }, 
        {
         "id":426,
         "type":"ground"
        }, 
        {
         "id":427,
         "type":"ground"
        }, 
        {
         "id":485,
         "type":"ground"
        }, 
        {
         "id":488,
         "type":"ground"
        }, 
        {
         "id":490,
         "type":"ground"
        }, 
        {
         "id":493,
         "type":"platform"
        }, 
        {
         "id":494,
         "type":"platform"
        }, 
        {
         "id":495,
         "type":"platform"
        }, 
        {
         "id":496,
         "type":"platform"
        }, 
        {
         "id":497,
         "type":"platform"
        }, 
        {
         "id":498,
         "type":"ground"
        }, 
        {
         "id":521,
         "type":"ground"
        }, 
        {
         "id":524,
         "type":"ground"
        }, 
        {
         "id":526,
         "type":"ground"
        }, 
        {
         "id":534,
         "type":"ground"
        }, 
        {
         "id":557,
         "type":"ground"
        }, 
        {
         "id":593,
         "type":"ground"
        }, 
        {
         "id":597,
         "type":"ground"
        }, 
        {
         "id":601,
         "type":"ground"
        }, 
        {
         "id":633,
         "type":"ground"
        }, 
        {
         "id":637,
         "type":"ground"
        }, 
        {
         "id":667,
         "type":"ground"
        }, 
        {
         "id":668,
         "type":"ground"
        }, 
        {
         "id":669,
         "type":"ground"
        }, 
        {
         "id":670,
         "type":"ground"
        }, 
        {
         "id":671,
         "type":"ground"
        }, 
        {
         "id":673,
         "type":"ground"
        }, 
        {
         "id":711,
         "type":"ground"
        }, 
        {
         "id":716,
         "type":"ground"
        }, 
        {
         "id":752,
         "type":"ground"
        }, 
        {
         "id":786,
         "type":"ground"
        }, 
        {
         "id":787,
         "type":"ground"
        }, 
        {
         "id":788,
         "type":"ground"
        }, 
        {
         "id":824,
         "type":"ground"
        }, 
        {
         "id":860,
         "type":"ground"
        }, 
        {
         "id":926,
         "type":"ground"
        }, 
        {
         "id":931,
         "type":"ground"
        }, 
        {
         "id":967,
         "type":"ground"
        }, 
        {
         "id":989,
         "type":"ground"
        }, 
        {
         "id":991,
         "type":"ground"
        }, 
        {
         "id":998,
         "type":"ground"
        }, 
        {
         "id":1001,
         "type":"ground"
        }, 
        {
         "id":1025,
         "type":"ground"
        }, 
        {
         "id":1027,
         "type":"ground"
        }, 
        {
         "id":1028,
         "type":"platform"
        }, 
        {
         "id":1034,
         "type":"ground"
        }, 
        {
         "id":1036,
         "type":"ground"
        }, 
        {
         "id":1037,
         "type":"ground"
        }, 
        {
         "id":1040,
         "type":"ground"
        }, 
        {
         "id":1061,
         "type":"ground"
        }, 
        {
         "id":1076,
         "type":"ground"
        }, 
        {
         "id":1097,
         "type":"ground"
        }, 
        {
         "id":1099,
         "type":"ground"
        }, 
        {
         "id":1104,
         "type":"ground"
        }, 
        {
         "id":1118,
         "type":"ground"
        }, 
        {
         "id":1120,
         "type":"ground"
        }, 
        {
         "id":1122,
         "type":"ground"
        }, 
        {
         "id":1124,
         "type":"ground"
        }, 
        {
         "id":1126,
         "type":"ground"
        }, 
        {
         "id":1133,
         "type":"ground"
        }, 
        {
         "id":1134,
         "type":"platform"
        }, 
        {
         "id":1135,
         "type":"ground"
        }, 
        {
         "id":1136,
         "type":"platform"
        }, 
        {
         "id":1138,
         "type":"platform"
        }, 
        {
         "id":1139,
         "type":"ground"
        }, 
        {
         "id":1140,
         "type":"ground"
        }, 
        {
         "id":1154,
         "type":"ground"
        }, 
        {
         "id":1156,
         "type":"ground"
        }, 
        {
         "id":1158,
         "type":"ground"
        }, 
        {
         "id":1160,
         "type":"ground"
        }, 
        {
         "id":1162,
         "type":"ground"
        }, 
        {
         "id":1169,
         "type":"ground"
        }, 
        {
         "id":1176,
         "type":"ground"
        }, 
        {
         "id":1220,
         "type":"ground"
        }, 
        {
         "id":1226,
         "type":"ground"
        }, 
        {
         "id":1228,
         "type":"ground"
        }, 
        {
         "id":1230,
         "type":"ground"
        }, 
        {
         "id":1262,
         "type":"ground"
        }, 
        {
         "id":1264,
         "type":"ground"
        }, 
        {
         "id":1266,
         "type":"ground"
        }, 
        {
         "id":1268,
         "type":"ground"
        }, 
        {
         "id":1377,
         "type":"ground"
        }, 
        {
         "id":1478,
         "type":"platform"
        }, 
        {
         "id":1479,
         "type":"platform"
        }, 
        {
         "id":1480,
         "type":"platform"
        }, 
        {
         "id":1481,
         "type":"platform"
        }, 
        {
         "id":1482,
         "type":"platform"
        }, 
        {
         "id":1483,
         "type":"ground"
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};